import React from 'react'
import { Link } from 'gatsby'

import Layout from '../../components/layout'
import Image from '../images/Mimi.Formal.Medium.jpg'
import SEO from '../../components/seo'

const IndexPage = () => (
  <Layout>
    <SEO title="Mimi Azoubel Daniel, M.S., PCC" keywords={[]} />
    <div>
      <div id="main" role="main">
        {' '}
        <div id="content" style={{ display: 'inline-block' }}>
          <h1 className="page-title">Mimi Azoubel Daniel, M.S., PCC</h1>
          <p>
            <img
              className="alignleft size-full wp-image-406"
              style={{ float: 'left' }}
              title="Mimi.Formal.Medium"
              src={Image}
              width={200}
            />
          </p>
          <p>
            Mimi brings over 25 years of business experience to her work with
            coaching clients. As the owner and founder of XY Outlook, Inc., she
            offers a blend of experience as an Executive Coach, Educator and
            Speaker. Her expertise includes working with C-Level/SES Leaders,
            Executives and Professionals at all levels on areas such as{' '}
            <span style={{ textDecoration: 'underline' }}>
              interpersonal skills
            </span>
            ,{' '}
            <span style={{ textDecoration: 'underline' }}>
              conflict management
            </span>
            ,{' '}
            <span style={{ textDecoration: 'underline' }}>
              collaboration/teamwork
            </span>{' '}
            and{' '}
            <span style={{ textDecoration: 'underline' }}>
              leadership development
            </span>
            . Mimi works with both the public and private sectors to create
            sustainable results that impact the organizational mission.
          </p>
          <p>
            There are many qualified executive coaches. However, Mimi’s area of
            expertise as an Executive Relations Coach is different. She
            specializes in working with executives who are highly skilled at
            their jobs and valuable to the organization, but are looking for
            skills to influence and motivate others, manage resistance, deal
            with politics and negotiate collaboration. Mimi addresses the
            sensitive leadership challenges that impact employee satisfaction.
            Her particular brand of coaching focuses on developing{' '}
            <span style={{ textDecoration: 'underline' }}>
              interpersonal strengths
            </span>
            , <span style={{ textDecoration: 'underline' }}>communication</span>{' '}
            and{' '}
            <span style={{ textDecoration: 'underline' }}>
              negotiation/conflict skills
            </span>{' '}
            that have led to measurable results in turnover, loyalty,
            responsiveness and productivity.
          </p>
          <p>
            Mimi has documented over 2500 total hours of executive coaching,
            enough to qualify for MCC status. She has 13 years experience as an
            executive coach and has considerable experience coaching
            high-profile leaders and teams at multiple federal government
            agencies. In the private sector, Mimi has most recently worked with
            senior leadership at Saft America, Inc., Genesis Rehabilitation
            Services, CJ Miller and Keller Foundations. In the past, Mimi has
            trained executives at MBNA Bank and TV Guide Corporation. In the
            public sector, Mimi has most recently worked with National Security
            Agency (NSA), National Institutes of Health (NIH), U.S. Department
            of Agriculture (USDA), U.S. General Services Administration (GSA),
            Office of Personnel Management (OPM), Department of Housing and
            Urban Development (HUD), and Health Resources and Services
            Administration (HRSA).
          </p>
          <p>
            Mimi is a Professional Certified Coach (PCC) through the
            International Coach Federation (ICF) and holds a master-level
            certification in Organization and Relationship System Coaching
            (ORSC) through the Coaches Training Institute (CTI). She is a
            Certified Trainer/Facilitator for the Shapiro Negotiations Institute
            delivering negotiations training to Fortune 500 companies and has
            also had Conflict Coaching training. Mimi received her bachelor’s
            degree from Dickinson College and holds a Masters of Science degree
            from Johns Hopkins University Carey School of Business, where she
            later served as an Adjunct Professor. Mimi has sat on the Board of
            Directors for the ICF Metro DC Chapter.
          </p>
          <p>
            Mimi coaches clients located across the country and is a frequent
            educator and speaker. She is based in Baltimore, Maryland.
          </p>
          <p>
            Phone: 443.956.4292 | Email:{' '}
            <a href="mailto:mimi@xyoutlook.com">mimi@xyoutlook.com</a>
          </p>
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage
